import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RegristrationRequestType } from "../../dto/RegistrationRequest.dto";
import { PaginationType } from "../../dto/Pagination.dto";
import { RegistrationRequestReducer } from "../Reducer/RegistrationRequest/RegistrationRequestReducer";
import { AllUsersReducer } from "../Reducer/AllUsers/AllUsersReducer";
import { AllUsersType } from "../../dto/AllUsers.dto";
import { UserManagementType } from "../../dto/User.dto";

export interface AllUsersSliceState {
  loading: boolean;
  verifyLoading: boolean;
  allUsers: AllUsersType[];
  UserManagement: UserManagementType[];
  pagination: PaginationType;
  userManagementPagination: PaginationType;
  siteSupervisorPagination: PaginationType;
  currentUser?: AllUsersType;
  allUserFilter: string;
  userManagementFilter: string;
}

const initialState: AllUsersSliceState = {
  loading: false,
  verifyLoading: false,
  allUsers: [],
  UserManagement: [],
  userManagementFilter: "",
  allUserFilter: "",
  pagination: {
    total_data: 0,
    current_page: 1,
    page_size: 7,
    total_pages: 1,
  },
  userManagementPagination: {
    total_data: 0,
    current_page: 1,
    page_size: 7,
    total_pages: 1,
  },
  siteSupervisorPagination: {
    total_data: 0,
    current_page: 1,
    page_size: 7,
    total_pages: 1,
  }
};

const allUsersSlice = createSlice({
  name: "allUsers",
  initialState,
  reducers: {
    setAllUsersPagination(state, action: PayloadAction<PaginationType>) {
      state.pagination = action.payload;
    },

    setAllUsersLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setUserManagementLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setUsersManagementPagination(state, action: PayloadAction<PaginationType>) {
      state.userManagementPagination = action.payload;
    },
    setSiteSupervisorPagination(state, action: PayloadAction<PaginationType>) {
      console.log('action.payload action.payloadaction.payload :>> ', action.payload);
      state.siteSupervisorPagination = action.payload
    },
    setUserManagementFilter(state, action: PayloadAction<string>) {
      state.userManagementFilter = action.payload;
    },
    setAllUsersFilter(state, action: PayloadAction<string>) {
      state.allUserFilter = action.payload;
    },
    resetUserManagementFilter(state) {
      state.userManagementFilter = '';
    },
    setCurrentUser(state, action: PayloadAction<AllUsersType>) {
      state.currentUser = action.payload;
    }
  },
  extraReducers: (builder) => {
    AllUsersReducer(builder);
  },
});
export const { setAllUsersPagination, setAllUsersLoading, setCurrentUser, setUsersManagementPagination, setUserManagementLoading, setUserManagementFilter,resetUserManagementFilter, setAllUsersFilter, setSiteSupervisorPagination } =
  allUsersSlice.actions;

export default allUsersSlice.reducer;
